import { KulionerReceiptSectionProps } from "../types";
import { colors } from "../constants";
import { formatDateWithoutTime } from "@/app/infrastructures/misc/Utils";
import { maskRecipientPhone } from "@/app/ui/modules/receipt-v2/module";

export const renderHeader = ({
  doc,
  x,
  y,
  pageWidth,
  data,
  importLogo
}: KulionerReceiptSectionProps): number => {
  const marginRight = 5;
  const boxRadius = 1.5;

  const paddingX = 2;
  const paddingY = 3;

  const containerX = x;
  const containerY = y;
  const boxWidth = pageWidth - marginRight - 0;

  doc.setFontSize(6);
  doc.setFont("Montserrat", "normal");
  const boxHeight = 10;
  const penerimaHeightBase = 16;
  const recipientAddress = data?.recipientAddress || "-";
  const splitAddress = doc.splitTextToSize(recipientAddress, 80);
  const addressLines = splitAddress.length;
  const penerimaHeight = penerimaHeightBase + (addressLines - 1) * 3;

  const contentHeight = boxHeight + 2 + penerimaHeight;

  const containerHeight = contentHeight + paddingY * 2;


  doc.setDrawColor("#F3F4F6");
  doc.setFillColor("#F5F5F5");
  doc.roundedRect(
    containerX,
    containerY,
    boxWidth,
    containerHeight,
    boxRadius,
    boxRadius,
    "FD"
  );

  const innerContentX = containerX + paddingX;
  const innerContentY = containerY + paddingY;
  const innerBoxWidth = boxWidth - paddingX * 2;

  const widthColumn = innerBoxWidth / 4;


  const boxX = innerContentX;
  const boxY = innerContentY;
  const boxWidth3Cols = widthColumn * 3;

  doc.setDrawColor("#E4E7E9");
  doc.setFillColor("#FFFFFF");
  doc.roundedRect(
    boxX,
    boxY,
    boxWidth3Cols,
    boxHeight,
    boxRadius,
    boxRadius,
    "FD"
  );

 
  doc.setDrawColor("#E4E7E9");
  for (let i = 1; i < 3; i++) {
    doc.line(
      boxX + widthColumn * i,
      boxY,
      boxX + widthColumn * i,
      boxY + boxHeight
    );
  }


  const renderColumn = (
    title: string,
    value: string,
    xOffset: number,
    isRed = false
  ) => {
    const colCenterX = xOffset + widthColumn / 2;

    doc.setFontSize(6);
    doc.setFont("Montserrat", "normal");
    doc.setTextColor("#78787A");
    const titleWidth = doc.getTextWidth(title);
    doc.text(title, colCenterX - titleWidth / 2, boxY + 4);

    doc.setFont("Montserrat", "bold");
    doc.setTextColor(isRed ? colors.accent : colors.primary);
    const valueWidth = doc.getTextWidth(value);
    doc.text(value, colCenterX - valueWidth / 2, boxY + 7);
  };

  renderColumn("Tanggal pesanan", formatDateWithoutTime(data?.createdAt), boxX);
  renderColumn("Order ID", data?.orderId || "-", boxX + widthColumn, true);
  renderColumn("Nomor STT", data?.orderSttNo || "-", boxX + widthColumn * 2, true);

 
  if (importLogo?.default) {
    try {
      const logo = importLogo.default;
      const logoMaxWidth = widthColumn - 4;
      const logoProps = doc.getImageProperties(logo);
      const aspectRatio = logoProps.height / logoProps.width;
      const logoHeight = logoMaxWidth * aspectRatio;

      const logoX = boxX + boxWidth3Cols + (widthColumn - logoMaxWidth) / 2;
      const logoY = boxY + (boxHeight - logoHeight) / 2;

      doc.addImage(
        logo,
        "PNG",
        logoX,
        logoY,
        logoMaxWidth,
        logoHeight,
        "logo",
        "FAST"
      );
    } catch (err) {
      console.error("Gagal menggambar logo:", err);
    }
  }


  y = boxY + boxHeight + 2;

  // === Recipient Section ===
  doc.setDrawColor("#E4E7E9");
  doc.setFillColor("#FFFFFF");

  doc.roundedRect(
    innerContentX,
    y,
    innerBoxWidth,
    penerimaHeight + 1,
    boxRadius,
    boxRadius,
    "FD"
  );

  // Label "Penerima"
  doc.setFontSize(6);
  doc.setFont("Montserrat", "bold");
  doc.setTextColor("#333333");
  doc.text("Penerima", innerContentX + 2, y + 4);

  // Inner info box
  const infoBoxY = y + 5;
  const infoBoxHeight = penerimaHeight - 6;
  const infoBoxRadius = 1.0;

  doc.setDrawColor("#EBEBEB");
  doc.setFillColor("#FFFFFF");
  doc.roundedRect(
    innerContentX + 2,
    infoBoxY,
    innerBoxWidth - 4,
    infoBoxHeight,
    infoBoxRadius,
    infoBoxRadius,
    "FD"
  );

  // Recipient text content inside info box
  const textStartX = innerContentX + 3;
  let textY = infoBoxY + 3;

  doc.setFont("Montserrat", "bold");
  doc.setTextColor("#333333");
  doc.text(data?.recipientName || "-", textStartX, textY);

  textY += 3;
  doc.text(
    maskRecipientPhone(data?.recipientPhoneNumber) || "-",
    textStartX,
    textY
  );

  textY += 3;
  doc.setFont("Montserrat", "normal");
  doc.setTextColor("#A7A8AA");
  splitAddress.forEach((line: string) => {
    doc.text(line, textStartX, textY);
    textY += 3; 
  });


  // Calculate final Y position after all content + padding bottom
  const finalY = y + penerimaHeight + paddingY;

  // Redraw outer container border only to ensure clean edges
  doc.setDrawColor("#F3F4F6");
  doc.setFillColor("#FFFFFF");
  doc.roundedRect(
    containerX,
    containerY,
    boxWidth,
    finalY - containerY,
    boxRadius,
    boxRadius,
    "S" // stroke only
  );

  return finalY;
};
